const historyQuality = {
	data() {
		return {
			qualityTable: []
		}
	},
	mounted() {
		this.getQualityList()
	},
	methods: {
		getQualityList() {
			this.$post('/reportApi/queryExamQuestionCompare', this.params).then(res => {
				let qualityTable = []
				res.data.forEach(res => {
					res.examInfoDTOList.forEach(resp => {
						qualityTable.push({ ...resp, subName: res.subName })
					})
				})
				this.qualityTable = qualityTable
			})
		}
	}
}
export default historyQuality
